module.exports = __webpack_public_path__ + "img/categoria-libros.4b4dffc8.png";